export default __webpack_public_path__ + "static/media/chatton18.94bdd9f2.jpeg";